import React from 'react';
import { Box, Flex, Text } from '@qga/roo-ui/components';
import { formatNumber } from 'accounting';
import PropTypes from 'prop-types';

const Points = ({ points }) => (
  <Box>
    <Flex alignItems="center" display="inline-flex">
      <Text fontSize="2xl" fontWeight="bold">
        {formatNumber(points)}
      </Text>
      <Text fontSize="sm" fontWeight="bold" pl="1">
        PTS^
      </Text>
    </Flex>
  </Box>
);

Points.propTypes = {
  points: PropTypes.number.isRequired,
};

export default Points;
